import { ContentBlock } from 'draft-js';

export interface StrLoc {
  begin: number;
  end: number;
}

export default (followupText: string, block: ContentBlock): StrLoc => {
  const begin = block.getText().lastIndexOf(followupText);
  const end = begin + followupText.length;
  return { begin, end };
};
